import React from "react";
import "./noAddressFound.scss";
import { Stack } from "@mui/material";

const NoAddressFound = () => {
  return (
    <div className="no-address-found">
      <Stack spacing={2}>
        <div className="title">No address currently added</div>
        <div className="sub-description">
          Why not add address and start beautiful product delivery to your
          address. Just click on the <b>New Address</b> button above to
          instantly go to the add address page. Oh, and while you're there, fill
          all of the details and save address.
        </div>
      </Stack>
    </div>
  );
};

export default NoAddressFound;
